import React, { useEffect } from 'react';
import classes from './Home12Company.module.scss';
import { Link } from 'react-router-dom';
import Home12Header from './Home12Header';

const companyRows = [
    { label: '会社名', value: 'コラボ株式会社' },
    { label: '所在地', value: '〒921-8163 石川県金沢市横川７丁目２６' },
    { label: 'TEL', value: '076-287-0026' },
    { label: '営業時間', value: '平日 10:00〜18:00' },
    { label: 'E-mail', value: 'sales@collabo.link' }
];

const Home12Company = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.root}>
            <Home12Header mode="fixed" />

            <main className={classes.mainContent}>
                <div className={classes.container}>
                    <div className={classes.formWrapper}>
                        <div className={classes.formHeader}>
                            <h1>運営会社</h1>
                            <p>collabo nexus を提供する、コラボ株式会社の会社情報です。</p>
                        </div>

                        <div className={classes.form}>
                            {companyRows.map((row) => (
                                <div key={row.label} className={classes.formGroup}>
                                    <label>{row.label}</label>
                                    <div className={classes.companyRowValue}>{row.value}</div>
                                </div>
                            ))}
                        </div>

                        <div className={classes.submitAction}>
                            <Link to="/contact" className={classes.home12LikeBtn}>お問い合わせは、こちら</Link>
                        </div>
                    </div>

                    <div className={classes.infoWrapper}>
                        <div className={classes.documentPreview}>
                            <img src="/react-assets/home10/home10-feature-support.jpg" alt="会社情報のイメージ" className={classes.previewImage} />
                            <div className={classes.previewOverlay}>
                                <h3>collabo Inc.<br />Company Profile</h3>
                                <ul>
                                    <li>- 現場で使える業務アプリの開発</li>
                                    <li>- DX/AX 推進の設計と実装支援</li>
                                    <li>- 導入後の継続的な改善サポート</li>
                                    <li>- データに基づく運用提案</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <footer className={classes.footer}>
                <div className={classes.footerLinks}>
                    <Link to="/privacy">プライバシーポリシー</Link>
                </div>
                <div className={classes.companyInfo}>
                    <p>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home12Company;
